module.exports = __webpack_public_path__ + "static/media/homeReport.230372bf.gif";